import * as React from 'react';
import { animated, useTransition } from '@react-spring/web';
import { HotkeyHandler } from '@mentimeter/hotkeys';
import { PortalOld } from '@mentimeter/ragnar-ui/portal';
import { ThemeMentiLight } from '@mentimeter/ragnar-ui/themes';

interface OverlayT {
  show: boolean;
  children: React.ReactNode;
  onDismiss: () => void;
}

export const Overlay = ({ show, onDismiss, children }: OverlayT) => {
  const transitions = useTransition(show, {
    from: {
      opacity: 0,
    },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  return (
    <PortalOld domId="overlay-portal">
      {transitions(
        (styles, show) =>
          show && (
            <animated.div
              id="overlay-enabled"
              style={{
                position: 'absolute',
                zIndex: 4,
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                ...styles,
              }}
            >
              <ThemeMentiLight>
                <HotkeyHandler keyCode="escape" onKeyUp={onDismiss} />
                {children}
              </ThemeMentiLight>
            </animated.div>
          ),
      )}
    </PortalOld>
  );
};
